import React, {Component} from 'react';
import LocalizedStrings from '../../../localization/strings';
import ImageForm from '../../../components/image/image-form';
export default class ImageContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            imageId: null
        }

    }
    onImageUploaded(values){
        this.setState({imageId: values.id, filename: values.filename});
    }
    render() {
        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.newImage}</header>
                <div className="panel-body">
                    <ImageForm onImageUploaded={this.onImageUploaded.bind(this)}/>

                {this.state.filename ? <div>{LocalizedStrings.url}: {`${window.CARE_CONFIG.image_storage_base_url_v2}${this.state.filename}`}</div>: null}
                </div>
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./src/js/containers/admin/image/image-container.js